import React from 'react'
import { LayoutProps } from '@pankod/refine-core'
import { EthereumClient } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/react'
import Head from 'next/head'
import { WagmiConfig } from 'wagmi'

import Header from '@/components/layout/Header'
import { chains, createWagmiClient, projectId } from '@/components/web3/wagmi.utils'
import public_styles from '@/css/public.module.css'

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const wagmiClient = createWagmiClient()
  const ethereumClient = new EthereumClient(wagmiClient, chains)
  return (
    <div>
      <Head>
        <link rel='apple-touch-icon' href='/apple-touch-icon.png' />
        <link rel='icon' type='image/png' sizes='32x32' href='/favicon-32x32.png' />
        <link rel='icon' type='image/png' sizes='16x16' href='/favicon-16x16.png' />
        <meta name='theme-color' content='#ffffff' />
        <link rel='manifest' href='/manifest.json' />
        <link rel='mask-icon' href='/mask-icon.svg' color='#5bbad5' />

        <title>Refine Web3 + JWT auth in domain-driven design</title>
        <meta property='og:image' content='/img/refine-hackathon-main@1024.png' key={'ogimage'} />
        <meta property='og:image:type' content='image/png' key={'ogimagetype'} />
        <meta property='og:image:width' content='1028' key={'ogimagew'} />
        <meta property='og:image:height' content='235' key={'ogimageh'} />
        <meta property='og:url' content={process.env.NEXT_PUBLIC_API_URL} />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:image' content='/img/refine-hackathon-main@1024.png' />

        <meta name='robots' content='noindex, nofollow' />
        <meta name='googlebot' content='noindex,nofollow' />
      </Head>
      <main className={public_styles.page__wrap}>
        <WagmiConfig client={wagmiClient}>
          <Header />
          {children}
        </WagmiConfig>
        <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
      </main>
    </div>
  )
}

export default Layout
